import { ExpansionPanelProps } from '@material-ui/core';
import { RefObject } from 'react';

export enum CompanyInformationTabs {
  Name = 'Name',
  Logo = 'Logo',
  Addresses = 'Addresses',
}

export interface CompanyInformationProps {
  isLoading: boolean
  updatedAt?: string
  onSave: () => void
}

export interface SettingsPanelProps extends ExpansionPanelProps {
  title: string
  info?: string
  containerRef?: RefObject<HTMLElement>
  isOutOfSync?: boolean
  onToggle: () => void
  onAddNew?: () => void
}

export interface HeaderLastSavedProps {
  timestamp: string
  loading?: boolean
  updateInterval?: number
}
